import { IDataSet } from '../Track';

export class MissionDataSet implements IDataSet {
    public missionID: string = undefined;
    public missionName: string = undefined;

    public mLevel: number = undefined;

    //public mLevelID: string = undefined;
    //public mLevelDifficulty: string = undefined;
    //public mLevelHard: number = undefined;

    public mLevelType: 'ALL_CARDS' | 'GOLD_CARDS' = 'ALL_CARDS';

    /**
     * Number of cards to clear to win the level:
     * ALL_CARDS = number of 'in-play' cards
     * GOLD_CARDS = number of golden cards
     */
    public mGoalAmount: number = 0;
    public mRetryNum: number = 0;
    public mIsSuccessRetry: number = 0;

    /**
     * Number of cards given in stack.
     */
    public mLevelMoves: number = 0;
    public mMovesLeft: number = 0;
    public mMovesMade: number = 0;

    public mHighestPlayStreak: number = 0;

    /**
     * Number of shuffle boosters used in current level.
     */
    public mChangerUsed: number = 0;

    /**
     * Number of bulls-eye boosters used in current level.
     */
    public mRemoveOneUsed: number = 0;

    /**
     * Number of TNT boosters used in current level.
     */
    public mMassRemoveUsed: number = 0;
    public mJokerUsed: number = 0;
    public mUndoUsed: number = 0;

    public mFreeEntryUsed: number = 0;
    public mPlus5Used: number = 0;

    /**
     * Number of pre booster remove 3 cards used in current level.
     */
    public mRemoveCardsBoostersUsed : number = 0;
    /**
     * Number of pre booster extra wild cards used in current level.
     */
    public mExtraWildcardsBoostersUsed : number = 0;
    /**
     * Number of pre booster canister card used in current level.
     */
    public mCanisterCardBoostersUsed : number = 0;

    public mExtraCardsBought: number = 0;
    public mExtraCardsWon: number = 0;
    public mJokerCardsWon: number = 0;
    public mCoinsSpent: number = 0;

    public mNoActionCardStreak: number = 0;
    public mNoPossibleActionStreak: number = 0;

    public mFriendHelped: number = 0;
    public mFriendWhoHelped: string = undefined;

    public mStars: number = undefined;

    public mLossAversionCoinsSpent: number = 0;
    public mNumBoostersUsedLossAversion: number = 0;

    public mScore: number = undefined;
    public mScoreBeforeEndSequence: number = undefined;

    /**
     * The number of coins bought during the level play with real money from the shop
     */
    public mCoinsBoughtWithRealMoney: number = undefined;

    /**
     * "The number of boosters bought with real money from the shop (this is currently only for
     *  the special offer)"
     */
    public mBoostersBoughtWithRealMoney: number = undefined;


    public mCoinsBoughtWithAds: number = undefined;

    /**
     * Denotes how many stars can be potentially still gained from this attempt at the level
     * (so for example if this is a replay of the level and in previous play the user got 1 star,
     * this would be 2)
     */
    public mChestStarsToGain: number = 0;

    /**
     * Denotes how many stars were gained in the course of the level
     * (so for example if this is a replay of the level and in previous play the user got 1 star
     * and in this play they got 2, this would be 1)
     */
    public mChestStarsGained: number = 0;

    //public mLevelTypeContext: LevelType = undefined;

    /**
     * Integer for number of cards remaining on game board when the mission was failed/succeeded
     */
    public mCardsLeftOnBoard: number = 0;

    /**
     * Describes the amount of coins that need to be paid in order to enter the level (even if the user entered with a booster)
     */
    public mEntryCoinCost: number = 0;

    /**
     * Describes whether the user had used a booster instead of coins to gain entry into the level
     */
    public mEntryWithBooster: number = undefined;

    /**
     * Counts the total amount of all streaks finished in that level
     */
    public mStreakNum: number = 0;

    /**
     * Counts the total amount of same-color streaks
     */
    public mStreakColorNum: number = 0;
}
